import React from "react";
import img1 from "../../images/achive2.jpg";
import img2 from "../../images/achive1.jpg";
import img3 from "../../images/achive3.JPG";
import { Box, Grid } from "@mui/material";
import Title from "../../components/title";

let key = 0;
const achievements = [
  {
    img: img1,
    title: "1st Runners-Up",
    prog: "Programming Combat 2022",
  },
  {
    img: img2,
    title: "First Problem Solver",
    prog: "Inter University Girls' Programming Contest-2019",
  },
  {
    img: img3,
    title: "Champion",
    prog: "MLH Hackathon-2018",
  },
];

const Achievements = () => {
  return (
    <Box sx={{ mt: 5 }}>
      <Title title="Achievements" />
      <Grid sx={{ mt: 5 }} container spacing={2}>
        {achievements.map((data) => (
          <Grid key={key++} item>
            <Box
              sx={{ minWidth: "300px" }}
              className="flex flex-col rounded-lg shadow-lg overflow-hidden"
            >
              <div className="flex-shrink-0">
                <img
                  className="h-48 w-full object-cover"
                  src={data.img}
                  alt=""
                />
              </div>

              <div className="flex-1 bg-white p-3 flex flex-col justify-between">
                <div className="flex-1 text-center">
                  <h6 className="mt-1 text-xl font-semibold text-gray-900">
                    {data.title}
                  </h6>
                  <p className="mt-2  text-gray-600">{data.prog}</p>
                </div>
              </div>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Achievements;
